module.exports = __webpack_public_path__ + "static/media/NICE_Step3a_Image1b.bd6ae112.jpg";